import { Button } from '@/components/common/Button';
import { DATE_YMD_HMS_12H_FORMAT } from '@/configs/constants';
import { useStore } from '@/hooks/useStore';
import { LANGUAGES_SUPPORTED } from '@/types/enums';
import { formatDateTime } from '@/utils/datetime';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface ViewNotificationModalProps {
    code: string
}

export default observer(function ViewNotificationModal({ code }: ViewNotificationModalProps) {
    // hooks
    const navigate = useNavigate();
    const { t, i18n: { language } } = useTranslation();

    // store
    const {
        notificationStore: { notificationDetail, getNotificationDetail },
        modalStore: { hideModal }
    } = useStore();

    // lifecycle
    useEffect(() => {
        getNotificationDetail(code);
    }, []);

    // function
    const onClickViewReceiveDetailForUser = (code) => {
        navigate(`/users/${code}`);
        hideModal();
    };

    const onClickViewReceiveDetailForShop = (code) => {
        navigate(`/shops/${code}`);
        hideModal();
    };

    return (
        <div>
            <div className='flex border-b border-border-1 py-4'>
                <div className='flex gap-4 w-1/2'>
                    <div className='text-text-4 w-2/5'>{t('words_title.send_date')}</div>
                    <div className='w-3/5'>{notificationDetail?.createdAt ? formatDateTime(notificationDetail.createdAt, DATE_YMD_HMS_12H_FORMAT) : ''}</div>
                </div>
                <div className='flex gap-4 w-1/2'>
                    <div className='text-text-4 w-2/5'>{t('words_title.receiver')}</div>
                    <div className='w-3/5'>
                        {
                            notificationDetail?.user ?
                                (
                                    <div className='underline text-link-1 cursor-pointer' onClick={() => onClickViewReceiveDetailForUser(notificationDetail.user.code)}>
                                        {notificationDetail?.user?.fullName ?? ''}
                                    </div>
                                ) :
                                (
                                    notificationDetail?.shop ?
                                        (
                                            (
                                                <div className='underline text-link-1 cursor-pointer' onClick={() => onClickViewReceiveDetailForShop(notificationDetail.shop.code)}>
                                                    {notificationDetail?.shop?.name ?? ''}
                                                </div>
                                            )
                                        ) :
                                        <></>
                                )
                        }
                    </div>
                </div>
            </div>
            <div className='py-4'>
                <div className='text-text-4'>{t('words_title.content')}</div>
                <div className='whitespace-pre-line'>
                    {notificationDetail?.content ?
                        (
                            language === LANGUAGES_SUPPORTED.English ? notificationDetail.content.en : notificationDetail.content.vi
                        ) :
                        ''}
                </div>
            </div>
            <div className='flex items-center justify-center mt-4'>
                <Button
                    className='bg-text-5 min-w-44 text-text-6'
                    onClick={() => hideModal()}
                >
                    {t('button.close')}
                </Button>
            </div>
        </div>
    );
});
